import ResourceList from '../../components/ResourceList';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toArray} from '../../util/idMap';
import {LoadCompaniesEpic} from '../../actions/companies.actions';
import {SelectCompanyEpic} from '../../actions/nav.actions';
import CircularProgress from 'material-ui/CircularProgress'
import RaisedButton from 'material-ui/RaisedButton';

/**
 * @augments {Component<{loadCompanies(): any, selectCompany(id:string): any, companies:[], loading: boolean}, {}>}
 */
class CompanyList extends Component {

 
  componentDidMount() {
    this.props.loadCompanies();
  }

  getColumns() {
    return [
      {name: 'name', label: 'Name'},
      {name: 'description', label: 'Description'},
      {name: 'readyEnabled', label: 'Ready Enabled'},
      {name: 'locationCount', label: 'Number of Locations'},
      {name: 'View', width: "90px", render: (rowData) => (<RaisedButton primary={true} onClick={() => this.props.selectCompany(rowData._id)} label="View"/>)}
    ];
  }

  render() {
    return (
      <div>
        <ResourceList columns={this.getColumns()} data={this.props.companies} showCheckboxes={false}/>
        {this.props.loading? <div style={{textAlign: 'center'}}><CircularProgress/></div> : null }
      </div>
    );
  }

}

const mapStateToProps = ({companiesEndpoint, authEndpoint}) => ({
  loading: companiesEndpoint.fetchInProgress,
  loadingError: companiesEndpoint.fetchError,
  companies: toArray(companiesEndpoint.companies),
})

const mapDispatchToProps = (dispatch) => ({
  loadCompanies: () => dispatch(LoadCompaniesEpic()),
  selectCompany: (companyId) => dispatch(SelectCompanyEpic(companyId))
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyList);


// WEBPACK FOOTER //
// ./src/containers/Companies/CompanyList.js